<script>
  import theme from "../stores/theme";
  $: bg = $theme.mode == "dark" ? "bg-brand-black" : "bg-white";

  export let icon = "react";
  export let toolName = "React JS";
  export let id;
</script>

<div
  data-aos="zoom-in-up"
  data-aos-offset="0"
  data-aos-delay={id * 50}
  class="aos-item flex flex-col items-center sm:flex-row sm:items-center mb-10"
>
  <div
    class={`skill-card ${bg} h-16 w-16 sm:h-20 sm:w-20 flex items-center justify-center shadow-md`}
  >
    <img
      class="h-12 w-12 sm:h-16 sm:w-16"
      src={`./icons/${icon}.svg`}
      alt={icon}
    />
  </div>

  <h1 class="mt-2 sm:mt-0 sm:ml-3 sm:text-lg">{toolName}</h1>
</div>

<style>
  .skill-card {
    border-top-right-radius: 25px;
    border-bottom-left-radius: 25px;
  }
</style>
